(function($) {
	function initMap($el) {
		// Find marker elements within map.
		var $markers = $el.find(".marker");

		// Create gerenic map.
		var mapArgs = {
			zoom: $el.data("zoom") || 16,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
		};
		var map = new google.maps.Map($el[0], mapArgs);

		// Add markers.
		map.markers = [];
		$markers.each(function() {
			initMarker($(this), map);
		});

		// Center map based on markers.
		centerMap(map);

		// Return map instance.
		return map;
	}

	function initMarker($marker, map) {
		// Get position from marker.
		var lat = $marker.data("lat");
		var lng = $marker.data("lng");
		var latLng = {
			lat: parseFloat(lat),
			lng: parseFloat(lng),
		};

		// Create marker instance.
		var marker = new google.maps.Marker({
			position: latLng,
			map: map,
			icon:
				"../wp-content/themes/morgan-feed-supplies/dist/images/map-marker.png",
		});

		// Append to reference for later use.
		map.markers.push(marker);

		// If marker contains HTML, add it to an infoWindow.
		if ($marker.html()) {
			// Create info window.
			var infowindow = new google.maps.InfoWindow({
				content: $marker.html(),
			});

			// Show info window when marker is clicked.
			google.maps.event.addListener(marker, "click", function() {
				infowindow.open(map, marker);
			});
		}
	}

	function centerMap(map) {
		// Create map boundaries from all map markers.
		var bounds = new google.maps.LatLngBounds();
		map.markers.forEach(function(marker) {
			bounds.extend({
				lat: marker.position.lat(),
				lng: marker.position.lng(),
			});
		});

		// Case: Single marker.
		if (map.markers.length == 1) {
			map.setCenter(bounds.getCenter());
			map.setZoom(10);

			// Case: Multiple markers.
		} else {
			var theCenter = bounds.getCenter();

			if (window.innerWidth >= 1024) {
				map.setCenter({ lat: theCenter.lat(), lng: theCenter.lng() + 15 });
				map.setZoom(4);
			} else {
				map.setCenter({ lat: theCenter.lat(), lng: theCenter.lng() + 11 });
				map.setZoom(3.5);
			}
		}
	}

	// Render maps on page load.
	/* eslint-disable */
	$(document).ready(function() {
		$(".acf-map").each(function() {
			var map = initMap($(this));
		});
	});
	/* eslint-enable */
})(jQuery);



// WEBPACK FOOTER //
// ./scripts/modules/map.js